export const useGetParams = () => {
  const searchParams = new URLSearchParams(window.location.search);

  const getDefaultValue = (value, defaultValue) => {
    if (value === '0') {
      return '';
    } else if (value) {
      return value;
    } else return defaultValue;
  };

  return {
    user: searchParams.get('user') || '',

    bgVideoQuestion: searchParams.get('bgVideoQuestion') || '1',
    bgPosterQuestion: searchParams.get('bgPosterQuestion') || null,

    bgImgQuestion: searchParams.get('bgImgQuestion') || null,

    title: getDefaultValue(searchParams.get('title'), 'Один\\nв один'),
    titleFontSize: searchParams.get('titleFontSize') || '16',

    // bgVideo: searchParams.get('bgVideo') || '1',
    // bgPoster: searchParams.get('bgPoster') || null,
  };
};
